import { Reveal } from "./Reveal";

const LINES = [
  "Un temps que l'on s'autorise.",
  "Un temps pour ralentir lorsque tout semble aller trop vite.",
  "Un temps pour retrouver le silence lorsque le quotidien devient trop bruyant.",
  "Un temps pour respirer lorsque les responsabilités prennent toute la place.",
];

export const Manifeste = () => {
  return (
    <section
      data-testid="manifeste-section"
      className="relative overflow-hidden bg-pblv-bg2 py-24 md:py-32"
    >
      <div className="mx-auto max-w-4xl px-5 text-center md:px-8">
        <Reveal>
          <img
            src="/logo-tpoz.jpg"
            alt="T'POZ — Répit • Ressourcement — un réseau porté par Plus Belle La Vie 971"
            data-testid="manifeste-logo"
            className="mx-auto mb-10 h-28 w-auto object-contain md:h-36"
            loading="lazy"
          />
        </Reveal>
        <Reveal>
          <p className="mb-8 text-xs font-semibold uppercase tracking-[0.3em] text-pblv-mauve">
            Une T'POZ, c'est…
          </p>
        </Reveal>
        <div className="flex flex-col gap-4">
          {LINES.map((line, i) => (
            <Reveal key={i} delay={i * 0.12} y={20}>
              <p className="font-serif text-2xl leading-snug text-pblv-ink md:text-4xl">
                {line}
              </p>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.6}>
          <p className="mx-auto mt-10 max-w-2xl text-lg leading-relaxed text-pblv-inksoft">
            C'est aussi un lieu où l'on n'a rien à prouver, où l'on peut
            simplement être soi-même. Une T'POZ n'efface pas les difficultés :
            elle ouvre un espace où l'on retrouve de l'énergie, où l'on se sent
            écoutée, accueillie et respectée.
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default Manifeste;
